var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import create from "zustand";
import { unstable_batchedUpdates } from "react-dom";
import Decimal from "decimal.js";
const subscribeWithSelector = (fn) => (set, get, api) => {
  const origSubscribe = api.subscribe;
  api.subscribe = (selector, optListener, options) => {
    let listener = selector;
    if (optListener) {
      const equalityFn = (options == null ? void 0 : options.equalityFn) || Object.is;
      let currentSlice = selector(api.getState());
      listener = (state) => {
        const nextSlice = selector(state);
        if (!equalityFn(currentSlice, nextSlice)) {
          const previousSlice = currentSlice;
          optListener(currentSlice = nextSlice, previousSlice);
        }
      };
      if (options == null ? void 0 : options.fireImmediately) {
        optListener(currentSlice, currentSlice);
      }
    }
    return origSubscribe(listener);
  };
  const initialState = fn(set, get, api);
  return initialState;
};
function detectProvider() {
  var _a;
  const providerType = arguments[0];
  const { mustBeMetaMask = false, mustBeFluent = false, silent = false, timeout = 0 } = (_a = arguments[1]) != null ? _a : {};
  _validateInputs();
  let handled = false;
  return new Promise((resolve, reject) => {
    if (window[providerType]) {
      handleEthereum();
    } else {
      window.addEventListener(`${providerType}#initialized`, handleEthereum, { once: true });
      if (timeout > 0) {
        setTimeout(() => {
          handleEthereum();
        }, timeout);
      } else {
        handleEthereum();
      }
    }
    function handleEthereum() {
      if (handled) {
        return;
      }
      handled = true;
      window.removeEventListener(`${providerType}#initialized`, handleEthereum);
      const provider2 = window[providerType];
      const mustBeOfficalWallet = providerType === "conflux" ? mustBeFluent : mustBeMetaMask;
      let isOfficalWallet = !!provider2;
      if (provider2 && mustBeOfficalWallet) {
        isOfficalWallet = providerType === "conflux" ? !!provider2.isFluent : !!provider2.isMetaMask;
      }
      if (provider2 && (!mustBeOfficalWallet || isOfficalWallet)) {
        resolve(provider2);
      } else {
        const message = mustBeOfficalWallet && provider2 ? `Non-${providerType === "conflux" ? "Fluent" : "MetaMask"} window.${providerType} detected.` : `Unable to detect window.${providerType}.`;
        !silent && console.error("detect-provider:", message);
        reject(message);
      }
    }
  });
  function _validateInputs() {
    if (typeof mustBeFluent !== "boolean") {
      throw new Error(`detect-provider: Expected option 'mustBeFluent' to be a boolean.`);
    }
    if (typeof mustBeMetaMask !== "boolean") {
      throw new Error(`detect-provider: Expected option 'mustBeMetaMask' to be a boolean.`);
    }
    if (typeof silent !== "boolean") {
      throw new Error(`detect-provider: Expected option 'silent' to be a boolean.`);
    }
    if (typeof timeout !== "number") {
      throw new Error(`detect-provider: Expected option 'timeout' to be a number.`);
    }
  }
}
const ratio = Decimal.pow(10, 18);
const _Unit = class {
  constructor(value) {
    __publicField(this, "value");
    __publicField(this, "equalsWith", (another) => {
      return this.value.eq(another.value);
    });
    __publicField(this, "toDecimalStandardUnit", (toFixed) => {
      if (typeof toFixed === "number" && toFixed > 0) {
        const strVal = this.value.div(ratio).toString();
        const dotIndex = strVal.indexOf(".");
        if (dotIndex === -1)
          return strVal + "." + "0".repeat(toFixed);
        if (strVal.length - dotIndex - 1 < toFixed)
          return strVal + "0".repeat(toFixed - (strVal.length - dotIndex - 1));
        return strVal.slice(0, dotIndex) + "." + strVal.slice(dotIndex + 1, dotIndex + toFixed + 1);
      }
      return this.value.div(ratio).toString();
    });
    __publicField(this, "toHexStandardUnit", () => {
      return this.value.div(ratio).toHex();
    });
    __publicField(this, "toDecimalMinUnit", () => {
      return this.value.toString();
    });
    __publicField(this, "toHexMinUnit", () => {
      return this.value.toHex();
    });
    this.value = value;
  }
  [Symbol.toPrimitive](hint) {
    return hint == "string" ? this.toDecimalStandardUnit() : this.value;
  }
};
let Unit = _Unit;
__publicField(Unit, "fromStandardUnit", (value) => {
  return new _Unit(new Decimal(value).mul(ratio));
});
__publicField(Unit, "fromMinUnit", (value) => {
  return new _Unit(new Decimal(value));
});
__publicField(Unit, "equals", (a, b) => {
  return a.value.eq(b.value);
});
__publicField(Unit, "add", (a, b) => {
  return new _Unit(a.value.add(b.value));
});
__publicField(Unit, "sub", (a, b) => {
  return new _Unit(a.value.sub(b.value));
});
__publicField(Unit, "mul", (a, b) => {
  return new _Unit(a.value.mul(b.value));
});
__publicField(Unit, "div", (a, b) => {
  return new _Unit(a.value.div(b.value));
});
class Wallet {
  constructor(providerType) {
    __publicField(this, "providerType");
    __publicField(this, "evtPrefix");
    __publicField(this, "balanceTimer", null);
    __publicField(this, "resolveDetect");
    __publicField(this, "detectPromise", new Promise((resolve) => this.resolveDetect = resolve));
    __publicField(this, "provider");
    __publicField(this, "store", create(subscribeWithSelector(() => ({
      status: "in-detecting",
      accounts: void 0,
      chainId: void 0,
      balance: void 0
    }))));
    __publicField(this, "subProvider", () => __async(this, null, function* () {
      this.store.subscribe(selectors.chainId, this.trackBalance);
      this.provider.on("accountsChanged", () => this.batchGetInfo());
      this.provider.on("chainChanged", () => this.batchGetInfo());
    }));
    __publicField(this, "handleAccountsChanged", (accounts) => {
      const hasAccount = !!(accounts == null ? void 0 : accounts[0]);
      if (hasAccount) {
        this.store.setState({ status: "active", accounts });
      } else {
        this.store.setState({ status: "not-active", accounts, balance: void 0 });
      }
    });
    __publicField(this, "handleChainChanged", (chainId) => {
      if (!chainId || chainId === "0xNaN") {
        this.store.setState({ chainId: void 0, status: "not-active", accounts: void 0, balance: void 0 });
        return;
      }
      const preChainId = this.store.getState().chainId;
      if (preChainId !== chainId) {
        this.store.setState({ chainId: String(parseInt(chainId)), balance: void 0 });
      }
    });
    __publicField(this, "handleBalanceChanged", (newBalance) => {
      if (!newBalance)
        return;
      const preBalance = this.store.getState().balance;
      if (preBalance === void 0 || !preBalance.equalsWith(newBalance)) {
        this.store.setState({ balance: newBalance });
      }
    });
    __publicField(this, "batchGetInfo", (..._0) => __async(this, [..._0], function* ({ isRequestConnect } = { isRequestConnect: false }) {
      try {
        const [chainId, accounts] = yield Promise.all([this.getChainId(), isRequestConnect ? this.requestAccounts() : this.getAccounts()]);
        const balance = yield this.getBalance(accounts);
        unstable_batchedUpdates(() => {
          this.handleAccountsChanged(accounts);
          this.handleChainChanged(chainId);
          this.store.setState({ balance });
        });
      } catch (err) {
        console.error("batchGetInfo error: ", err);
        throw err;
      } finally {
        this.resolveDetect();
      }
    }));
    __publicField(this, "requestAccounts", () => {
      const preStatus = this.store.getState().status;
      if (preStatus !== "active") {
        this.store.setState({ status: "in-activating" });
      }
      const promise = this.provider.request({ method: `${this.evtPrefix}_requestAccounts` });
      promise.catch(() => this.store.setState({ status: "not-active" }));
      return promise;
    });
    __publicField(this, "getAccounts", () => this.provider.request({ method: `${this.evtPrefix}_accounts` }));
    __publicField(this, "getChainId", () => this.provider.request({ method: `${this.evtPrefix}_chainId` }));
    __publicField(this, "getBalance", (accounts) => __async(this, null, function* () {
      var _a;
      const account = accounts ? accounts[0] : (_a = this.store.getState().accounts) == null ? void 0 : _a[0];
      if (!account)
        return;
      try {
        const minUnitBalance = yield this.provider.request({
          method: `${this.evtPrefix}_getBalance`,
          params: [account, this.evtPrefix === "cfx" ? "latest_state" : "latest"]
        });
        return Unit.fromMinUnit(minUnitBalance);
      } catch (err) {
        console.error("Get balance error: ", err);
        throw err;
      }
    }));
    __publicField(this, "checkConnected", () => {
      var _a;
      const account = (_a = this.store.getState().accounts) == null ? void 0 : _a[0];
      if (!account) {
        throw new Error("Operate error: request connect to wallet.");
      }
      return account;
    });
    __publicField(this, "trackBalance", () => {
      var _a;
      const account = (_a = this.store.getState().accounts) == null ? void 0 : _a[0];
      const clearTimer = () => {
        if (typeof this.balanceTimer === "number") {
          clearInterval(this.balanceTimer);
          this.balanceTimer = null;
        }
      };
      if (!account) {
        this.store.setState({ balance: void 0 });
        clearTimer();
        return;
      }
      clearTimer();
      const getAndSetBalance = () => this.getBalance().then((balance) => this.handleBalanceChanged(balance));
      getAndSetBalance();
      this.balanceTimer = setInterval(getAndSetBalance, 1500);
    });
    __publicField(this, "connect", () => {
      const currentStatus = this.store.getState().status;
      if (currentStatus !== "not-active") {
        if (currentStatus === "active")
          throw Promise.resolve();
        else
          throw new Error(`currentStatus can't activate`);
      }
      return this.batchGetInfo({ isRequestConnect: true });
    });
    __publicField(this, "sendTransaction", (params) => {
      const account = this.checkConnected();
      if (typeof params !== "object") {
        throw new Error("sendTransaction error: params must be object.");
      }
      return this.provider.request({
        method: `${this.evtPrefix}_sendTransaction`,
        params: [__spreadProps(__spreadValues({}, params), {
          from: account
        })]
      });
    });
    __publicField(this, "personalSign", (message) => {
      const account = this.checkConnected();
      return this.provider.request({
        method: "personal_sign",
        params: [message, account]
      });
    });
    __publicField(this, "typedSign", (typedData) => {
      const account = this.checkConnected();
      if (typeof typedData !== "object") {
        throw new Error("typedSign error: typedData must be object.");
      }
      return this.provider.request({
        method: `${this.evtPrefix}_signTypedData_v4`,
        params: [account, JSON.stringify(typedData)]
      });
    });
    __publicField(this, "addChain", (param) => {
      return this.provider.request({
        method: `wallet_add${this.providerType}Chain`,
        params: [param]
      });
    });
    __publicField(this, "switchChain", (chainId) => {
      return this.provider.request({
        method: `wallet_switch${this.providerType}Chain`,
        params: [{ chainId }]
      });
    });
    __publicField(this, "watchAsset", (param) => {
      if (!param) {
        throw new Error("watchAsset error: param must be object.");
      }
      return this.provider.request({
        method: "wallet_watchAsset",
        params: param
      });
    });
    __publicField(this, "trackBalanceChangeOnce", (callback) => {
      if (!callback)
        return;
      let unsubBalance = null;
      let unsubAccount = null;
      unsubAccount = this.store.subscribe(selectors.accounts, () => {
        if (!unsubAccount)
          return;
        if (unsubBalance) {
          unsubBalance();
        }
        unsubAccount();
        unsubAccount = null;
      });
      unsubBalance = this.store.subscribe(selectors.balance, () => {
        if (!unsubBalance)
          return;
        callback();
        unsubBalance();
        unsubBalance = null;
      });
    });
    __publicField(this, "useStatus", () => this.store(selectors.status));
    __publicField(this, "useAccount", () => this.store(selectors.account));
    __publicField(this, "useChainId", () => this.store(selectors.chainId));
    __publicField(this, "useBalance", () => this.store(selectors.balance));
    __publicField(this, "completeDetect", () => this.detectPromise);
    this.providerType = providerType === "conflux" ? "Conflux" : "Ethereum";
    this.evtPrefix = providerPreFixMap[providerType];
    detectProvider(arguments[0], arguments[1]).then((provider2) => {
      this.provider = provider2;
      if (provider2.isConfluxPortal && provider2.send && !provider2.request) {
        this.provider.request = ({ method, params }) => {
          var _a;
          if (method === "accounts")
            return Promise.resolve(this.provider.selectedAddress);
          if (method === "cfx_chainId")
            return Promise.resolve(this.provider.networkVersion);
          return (_a = this.provider) == null ? void 0 : _a.send(method, params);
        };
      }
      this.batchGetInfo();
      this.subProvider();
    }).catch((err) => {
      console.error("detect error:", err);
      this.store.setState({ status: "not-installed" });
      this.resolveDetect();
    });
  }
}
const selectors = {
  status: (state) => state.status,
  accounts: (state) => state.accounts,
  account: (state) => {
    var _a;
    return (_a = state.accounts) == null ? void 0 : _a[0];
  },
  chainId: (state) => state.chainId,
  balance: (state) => state.balance
};
const providerPreFixMap = {
  conflux: "cfx",
  ethereum: "eth"
};
const FluentWallet = new Wallet("conflux");
const provider = FluentWallet.provider;
const completeDetect = FluentWallet.completeDetect;
const connect = FluentWallet.connect;
const sendTransaction = FluentWallet.sendTransaction;
const addChain = FluentWallet.addChain;
const switchChain = FluentWallet.switchChain;
const watchAsset = FluentWallet.watchAsset;
const personalSign = FluentWallet.personalSign;
const typedSign = FluentWallet.typedSign;
const trackBalanceChangeOnce = FluentWallet.trackBalanceChangeOnce;
const useStatus = FluentWallet.useStatus;
const useAccount = FluentWallet.useAccount;
const useChainId = FluentWallet.useChainId;
const useBalance = FluentWallet.useBalance;
export { Unit, addChain, completeDetect, connect, Wallet as default, personalSign, provider, sendTransaction, switchChain, trackBalanceChangeOnce, typedSign, useAccount, useBalance, useChainId, useStatus, watchAsset };
